import ChevronRightRounded from '@mui/icons-material/ChevronRightRounded';
import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import RaceGif1 from "../../../../assets/gif/race1.gif";
import AnimatedTitleAndDescription from '../../../core/AnimatedTitleAndDescription';
import GlassSwipeButton from '../../../core/GlassSwipeButton';

interface LeftSectionProps { }

const LeftSection: React.FC<LeftSectionProps> = () => {
    const navigate = useNavigate();

    const { t } = useTranslation();

    return (
        <AnimatedTitleAndDescription title={(
            <Typography variant="h3" fontWeight={600} component="h1" gutterBottom color="text.primary">
                {t("landing.title")}
            </Typography>
        )}>
            <>
                <Typography sx={{ mb: 2 }} color="text.primary">
                    {t("landing.first")}
                </Typography>
                <Typography color="text.primary">
                    {t("landing.second")}
                </Typography>

                <GlassSwipeButton
                    onClick={() => navigate(`/tours?tourId=2`)}
                    sx={{ mt: 4, width: '100%' }}
                    size="large"
                    endIcon={<ChevronRightRounded sx={{ fontSize: 26 }} />}
                >
                    {t("landing.reserveButton")}
                    <img src={RaceGif1} height={38} className='motor-icon' alt="loading..." />
                </GlassSwipeButton>
            </>
        </AnimatedTitleAndDescription>
    );
};

export default LeftSection;
